'use client';

import { __awaiter, __generator } from '../../../_virtual/_tslib.js';
import React__default, { useContext, useEffect } from 'react';
import { InputWrapper, Title } from '../DropdownContainer/DropdownContainer.css.js';
import Input from '../../../Input/index.js';
import { CascaderContext } from '../../context/reducer.js';
import { ACTIONS } from '../../context/actions.js';
import SearchIcon from '../../../GlyphIcons/SearchIcon/index.js';
import { DropdownHeaderWrapper, RemoveAllSection, RemoveBtn, ResponsiveHeader } from './DropdownHeader.css.js';
import { getSelectedParentName } from '../../helper.js';
import Button from '../../../Button/index.js';
import GlyphIcons from '../../../GlyphIcons/index.js';
import { searchJobFunctions } from '../../services.js';
import useDebounce from '../../../Utils/hooks.js';

var DropdownHeader = function (params) {
    var isShowTitle = params.isShowTitle;
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state, t = _a.t, dispatch = _a.dispatch;
    var isMobile = props.isMobile, options = props.options, selectOptions = props.selectOptions, msBaseUrl = props.msBaseUrl, onConfirm = props.onConfirm, onBlur = props.onBlur;
    var keyword = state.keyword, parentId = state.parentId, temporaryValue = state.temporaryValue;
    var debounceKeyword = useDebounce([keyword], 300);
    var getSearchResult = function (keyword) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(options === null || options === void 0 ? void 0 : options.isEnableSearchAPI)) {
                        return [2 /*return*/];
                    }
                    if (keyword === '') {
                        // reset search result
                        dispatch({
                            type: ACTIONS.SET_SEARCH_RESULT,
                            payload: {
                                groupJobFunctions: [],
                                jobFunctions: []
                            }
                        });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, searchJobFunctions(msBaseUrl, keyword)];
                case 1:
                    response = _a.sent();
                    dispatch({
                        type: ACTIONS.SET_SEARCH_RESULT,
                        payload: response
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var onInputChange = function (value) {
        dispatch({
            type: ACTIONS.SET_KEYWORD,
            payload: value
        });
    };
    var onClickBack = function () {
        dispatch({
            type: ACTIONS.SET_SELECT_PARENT_ID,
            payload: -1
        });
    };
    var renderTitle = function () {
        if (!isShowTitle) {
            return React__default.createElement(React__default.Fragment, null);
        }
        if (!isMobile) {
            return React__default.createElement(Title, null, t('Job Function'));
        }
        var parentItem = getSelectedParentName([
            {
                parentId: parentId,
                childrenIds: [-1]
            }
        ], options.parent);
        if (parentItem.length === 0) {
            return React__default.createElement(Title, null, t('Job Function'));
        }
        return (React__default.createElement(ResponsiveHeader, null,
            React__default.createElement(Button, { isRounded: true, tabIndex: -1, isIcon: true, outline: 'none', type: 'default', size: 'sm', onClick: onClickBack },
                React__default.createElement(GlyphIcons.BackArrowIcon, { width: 20, height: 20 })),
            React__default.createElement(Title, null, parentItem[0].name)));
    };
    var onClickRemoveAll = function (e) {
        e.preventDefault();
        dispatch({
            type: ACTIONS.REMOVE_ALL_TEMPORARY_VALUE
        });
        if (selectOptions.hiddenFooter) {
            dispatch({
                type: ACTIONS.APPLY_CALLBACK,
                payload: onConfirm
            });
            dispatch({
                type: ACTIONS.SYNC_TEMPORARY_TO_VALUE
            });
        }
        if (selectOptions.isSingleSelect) {
            // update on single
            onConfirm && onConfirm([]);
            onBlur && onBlur();
            dispatch({
                type: ACTIONS.ON_CONFIRM
            });
        }
    };
    useEffect(function () {
        if (!debounceKeyword) {
            return;
        }
        getSearchResult(keyword);
    }, [debounceKeyword]);
    return (React__default.createElement(DropdownHeaderWrapper, { "data-cname": 'dropdown__header' },
        renderTitle(),
        React__default.createElement(InputWrapper, null,
            React__default.createElement(Input, { value: keyword, autoFocus: true, onChange: onInputChange, placeholder: t('Search'), prefixIcon: React__default.createElement(SearchIcon, null) })),
        temporaryValue.length > 0 && (React__default.createElement(RemoveAllSection, null,
            React__default.createElement(RemoveBtn, { onClick: onClickRemoveAll, href: '#' }, t('Remove all'))))));
};

export { DropdownHeader as default };
//# sourceMappingURL=index.js.map
